<template>
    <div>
        <h1 class="heading-text">Send Bulk SMS</h1>
        <form class="content-form">
            <!-- <div class="form-group">
                <label for="" class="control-label">Select Number</label>
                <select name="" id="" class="form-control" v-model="setBulk.client_bulk_num">
                    <option value="9849985782">9849985782</option>
                </select>
            </div> -->

            <div class="form-group sms-form">
                <label for="" class="control-label">Message</label>
                <textarea class="form-control message-text" rows="10" v-model="setBulk.sms"></textarea>
                <div class="text-count" v-text="setBulk.sms.length"></div>
            </div>

            <el-form>
                <el-form-item class="toggle-switch" label="Send Bulk for Everyone" prop="delivery" style="margin-bottom:15px;">
                    <el-switch v-model="setBulk.to_all"></el-switch>
                </el-form-item>
            </el-form>

            <el-form v-if="setBulk.to_all == false" style="margin-bottom:15px;">
                <el-form-item class="toggle-switch" label="Send Bulk for Groups" prop="delivery">
                    <el-switch v-model="to_group"></el-switch>
                </el-form-item>

                <div class="form-group select-group" v-if="to_group == true" style="padding-top:10px; margin-top:15px; margin-bottom: 0px;">
                    <el-checkbox-group
                    v-model="checkList">
                        <el-checkbox
                        v-for="groupDetaillist in groupDetail"
                        :key="groupDetaillist.id"
                        :label="groupDetaillist.id">{{groupDetaillist.group_name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-form>

            <div class="form-group">
                <label for="" class="control-label">Add Numbers</label>
                <textarea class="form-control message-text" rows="3" v-model="setBulk.numbers"></textarea>
                <p class="info text-info">use <b>" , " </b> (comma) after each number</p>
            </div>

            <button type="button" class="btn eg-btn submit-btn" @click="sendBulkConfirm">Send Bulk</button>

        </form>
    </div>
</template>


<script>
import axios from 'axios';
import {getusergroups, sendBulkUrl, getHeader} from './../../../config';

export default {
    data() {
        return {
            to_group: false,
            checkList: [],
            myNumber: JSON.parse(window.sessionStorage.getItem('mycontact')),
            groupDetail: [{
                id: "",
                group_name:"",
                group_description: ""
                
            }],
            setBulk: {
                sms: "",
                to_all: true,
                numbers: "",
                client_bulk_num: ""
            }
        }
    },
    methods: {
        clearbulkdata() {
            this.checkList = []
            this.setBulk.sms = ""
            this.setBulk.to_all = true
            this.setBulk.numbers = ""
            this.setBulk.client_bulk_num = ""
            this.to_group = false
        },
        sendBulkConfirm() {
            this.$confirm('Are you sure you want to send bulk?', 'Confirm', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'success'
            }).then(() => {
                this.sendBulk()
            }).catch(() => {
                // if user cancils click
                console.log("canciled")
            });
        },
        sendBulk(){
            // axios
            // .post(sendBulkUrl,this.setBulk,{headers: getHeader()})
            // .then (Response => {
            //     console.log("bulk sms sent")
            // })
            // .catch(function (error){
            //     console.log(error);
            // });

            if(this.setBulk.to_all == true){
                axios
                .post(sendBulkUrl,{client_bulk_num: this.myNumber,numbers: this.setBulk.numbers, sms: this.setBulk.sms, to_all: true, to_group: false},{headers: getHeader()})
                .then (Response => {
                    if(Response.data.error != "true"){
                        console.log(Response)
                        this.$nextTick(function () {
                            this.clearbulkdata()
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'Bulk Sent',
                                text: 'Bulk SMS sent successfully!'
                            })
                        })
                    }
                    else{
                        console.log(Response)
                    }
                })
                .catch(function (error){
                    console.log(error);
                });
            }

            else if(this.setBulk.to_all == false && this.to_group == false){
                axios
                .post(sendBulkUrl,{client_bulk_num: this.myNumber,numbers: this.setBulk.numbers, sms: this.setBulk.sms, to_all: false, to_group: false},{headers: getHeader()})
                .then (Response => {
                    if(Response.data.error != "true"){
                        console.log(Response)
                        this.$nextTick(function () {
                            this.clearbulkdata()
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'Bul Sent',
                                text: 'Bulk SMS sent successfully!'
                            })
                        })
                    }
                    else{
                        console.log(Response)
                    }
                })
                .catch(function (error){
                    console.log(error);
                });
            }

            else if(this.setBulk.to_all == false && this.to_group == true){
                axios
                .post(sendBulkUrl,{client_bulk_num: this.myNumber,numbers: this.setBulk.numbers, sms: this.setBulk.sms, to_all: false, to_group: this.checkList},{headers: getHeader()})
                .then (Response => {
                    if(Response.data.error != "true"){
                        console.log(Response)
                        this.$nextTick(function () {
                            this.clearbulkdata()
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                title: 'Bul Sent',
                                text: 'Bulk SMS sent successfully!'
                            })
                        })
                    }
                    else{
                        console.log(Response)
                    }
                })
                .catch(function (error){
                    console.log(error);
                });
            }

            else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error!!!',
                    text: 'Something went wrong. Cant set bulk'
                })
            }
        },
    },

    mounted() {
        axios
        .get(getusergroups, {headers: getHeader()})
        .then(Response =>{
            // console.log(Response)
            this.groupDetail = Response.data.data
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/parts/bulkman.vue